<template>
  <sweet-modal ref="modal" overlay-theme="dark" icon="success">
    <div v-if="newOrderData">
      <div class="mt-4">
        <h3>
          <template v-if="newOrderData.isInstantBooking">
            <i class="fas fa-bolt -status-instant-book"></i>
            {{ $t('message.booking.complete_step.title_instant_booking') }}
          </template>
          <template v-else>
            {{ $t('message.booking.complete_step.title') }}
          </template>
          — {{ $t('message.my_reservations.booking') }} #{{ newOrderData.orderCode }}
        </h3>
        <div class="mt-4">
          {{ $t('message.booking.checkout_step.success_message01') }}
        </div>
        <div class="mt-3">
          {{ $t('message.booking.checkout_step.success_message02') }}
        </div>
        <div class="mt-3 text-info">
          {{ $t('message.booking.checkout_step.success_message03') }}
        </div>
        <div class="mt-4">
          <button class="btn btn-info btn-block" @click.prevent="goToMyBooking">
            {{ $t('message.booking.complete_step.view_my_booking') }}
          </button>
        </div>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { SweetModal } from 'sweet-modal-vue'
  import insiderHelpers from '../../../helpers/insiderHelpers'

  export default {
    components: {
      SweetModal
    },
    computed: {
      ...mapGetters({
        newOrderData: 'booking/getNewOrderData',
        selectedProfessional: 'booking/getSelectedProfessional',
        user: 'auth/getUser'
      })
    },
    methods: {
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      },
      goToMyBooking () {
        this.closeModal()
        this.$router.push('/reservation/' + this.newOrderData.id)
      },
      chatWithCleaner () {
        if (this.newOrderData) {
          const path = '/message?cid=' + this.newOrderData.chatRoomId + '&pid=' + this.newOrderData.selectedProfessional.id
          this.$router.push(path)
        }
        this.closeModal()
      }
    },
    watch: {
      async newOrderData () {
        // If complete adding order
        if (this.newOrderData && this.newOrderData.paidStatus === 1) {
          // Insider purchase event
          const params = {
            user: this.user,
            orderId: this.newOrderData.id
          }
          await insiderHelpers.purchaseEvent(params)
          setTimeout(() => {
            this.openModal()
          }, 250)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/SuccessBookingModal.vue